import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { brandImage } from '../../config/branding';
import { useBranding } from '../../context/BrandingContext';
import charger from '../../utils/api/charger';

/**
 * Navbar component
 */
function Navbar() {
  const { i18n } = useTranslation();
  const { brandData } = useBranding();
  const [chargerDetails, setChargerDetails] = useState<{
    chargingPointName: string;
    chargingStation: {
      name: string;
    };
  }>({
    chargingPointName: '',
    chargingStation: {
      name: '',
    },
  });
  const { deviceId } = useParams<{ deviceId: string }>(); // Extracts the ID from the URL

  /**
   * Get charger details
   */
  const getChargerDetails = async () => {
    try {
      const response = await charger.fetchOneDevicePoints(deviceId ?? '');
      const apiResponse = response.data;
      setChargerDetails(apiResponse);
    } catch (error: any) {
      console.error('Failed to fetch charger details:', error);
    }
  };
  useEffect(() => {
    getChargerDetails();
  }, []);

  const logo = brandData?.logoUrl || brandData?.logo || brandImage.logo;

  return (
    <div className={`navbar-wrap ${i18n.dir() === 'rtl' ? 'rtl' : ''}`}>
      <img
        src={logo}
        alt=""
        className={`navbar-logo ${brandData?.clientName === 'saqr-tech' ? 'saqr-tech' : ''}`}
      />{' '}
      <div className="left-pane">
        <p>{chargerDetails.chargingPointName}</p>
        <p>{chargerDetails.chargingStation.name}</p>
      </div>
    </div>
  );
}

export default Navbar;
